import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AlertService } from '../../services/alert.service';
import { UserInfo } from '../../models/user';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'accept-terms',
  templateUrl: './accept-terms.component.html',
})
export class AcceptTermsComponent implements OnInit {
  tosContent = 'Loading...';
  acceptForm: FormGroup;
  loading = false;
  submitted = false;
  currentUser: UserInfo;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService
  ) {
    this.authenticationService.currentUser.subscribe(
      (x) => (this.currentUser = x)
    );
  }

  ngOnInit(): void {
    const tosContentURL = '/assets/terms-of-use-v1.html';
    this.alertService.clear();
    this.authenticationService
      .getHTMLContent(tosContentURL)
      .subscribe((html: any) => (this.tosContent = html));
    this.acceptForm = this.formBuilder.group({});
  }

  // convenience getter for easy access to form fields
  get f(): { [key: string]: AbstractControl } {
    return this.acceptForm.controls;
  }
  goBack(): void {
    this.router.navigate(['/']);
  }

  onSubmit(): void {
    this.submitted = true;

    // stop here if form is invalid
    if (this.acceptForm.invalid) {
      return;
    }

    this.loading = true;
    this.authenticationService
      .acceptTerms()
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          this.router.navigate(['/']);
        },
        (err) => {
          this.alertService.error(err.error);
          this.loading = false;
          this.router.navigate(['/']); // redirect if error AUS-514
        }
      );
  }
}
